import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CandlestickConditionDefaultService } from '../../_services/candlestick-condition-default.service';
import { fail } from 'assert';
import { Observable } from 'rxjs/Observable';
import { CoinConfigService } from '../../_services/coinconfig.service';
import { LineBotService } from '../../_services/line-bot.service';
import { EmaService } from '../../_services/ema.service';

@Component({
    selector: 'app-candlestick-condition-default',
    templateUrl: './candlestick-condition-default.component.html',
    styleUrls: ['./candlestick-condition-default.component.css']
})
export class CandlestickConditionDefaultComponent implements OnInit {
    model: any = {};
    markets: Observable<any[]>;
    currentConditionOneBuy: any = '86400';
    currentConditionOneSell: any = '86400';
    currentConditionTwoBuy: any = '1800';
    currentConditionTwoSell: any = '1800';
    coinCondition_1: any = [];
    coinCondition_2: any = [];
    msgErrorConditionOneBuy: any;
    msgErrorConditionOneSell: any;
    isValidateCondition: any = true;
    msgErrorConditions: any = '';
    marketId: number;
    lineBotAlls: any[];
    lineBotId: number;

    currentEmaBuy1: any;
    currentEmaBuy2: any;
    currentEmaSell1: any;
    currentEmaSell2: any;
    emaDefault1: any = [];
    emaDefault2: any = [];
    isValidateEma: any = true;
    msgErrorEma: any = '';

    constructor(
        private candlestickConditionDefaultService: CandlestickConditionDefaultService,
        private coinConfigService: CoinConfigService,
        private lineBotService: LineBotService,
        private emaService: EmaService
    ) {
        this.markets = this.coinConfigService.getMarkets();
    }

    ngOnInit() {
        let self = this;
        this.lineBotService.getLineBot().subscribe(res => {
            if (res.length && res[0].hasOwnProperty('id')) {
                self.lineBotAlls = res;
                self.lineBotId = res[0].id;
                self.getFirstItems(this.markets, resMarket => {
                    self.marketId = resMarket;
                    if (self.marketId && self.lineBotId) {
                        self.changeConditions({marketID: self.marketId, lineBotId: self.lineBotId});
                    }
                });
            }
        });

    }

    onChangeCondition(event) {
        this.changeConditions({marketID: this.marketId, lineBotId: this.lineBotId})
    }

    changeConditions(dataRequest){
        let self = this;
        this.candlestickConditionDefaultService.getConditions(dataRequest).subscribe(res => {
            self.coinCondition_1 = res.condition_1;
            self.coinCondition_2 = res.condition_2;
            if (res.current) {
                self.currentConditionOneBuy = res.current.condition_buy_default_1;
                self.currentConditionOneSell = res.current.condition_sell_default_1;
                self.currentConditionTwoBuy = res.current.condition_buy_default_2;
                self.currentConditionTwoSell = res.current.condition_sell_default_2;
            } else {
                self.currentConditionOneBuy = res.default.condition_buy_1.value;
                self.currentConditionOneSell = res.default.condition_sell_1.value;
                self.currentConditionTwoBuy = res.default.condition_buy_2.value;
                self.currentConditionTwoSell = res.default.condition_sell_2.value;
            }
        });

        this.emaService.getConditions(dataRequest).subscribe(res => {
            console.log(res);
            this.emaDefault1 = res.ema_values;
            this.emaDefault2 = res.ema_values;
            if (res.current) {
                this.currentEmaBuy1 = +res.current.ema_buy_default_1;
                this.currentEmaBuy2 = +res.current.ema_buy_default_2;
                this.currentEmaSell1 = +res.current.ema_sell_default_1;
                this.currentEmaSell2 = +res.current.ema_sell_default_2;
            }
        });
    }
    // get data id line bot or id market
    private getFirstItems(resObservable, callback){
        resObservable.subscribe(response => {
            if (response.length && response[0].hasOwnProperty('id')){
                callback(response[0].id);
            }
        });
    }

    save() {
        this.model.market_id = +$('#market').val();
        this.model.line_bot_id = +$('#lineBot').val();
        this.model.condition_buy_1 = +$('input[name=condition_buy_1]:checked', '.form').attr('ng-reflect-value');
        this.model.condition_sell_1 = +$('input[name=condition_sell_1]:checked', '.form').attr('ng-reflect-value');
        this.model.condition_buy_2 = +$('input[name=condition_buy_2]:checked', '.form').attr('ng-reflect-value');
        this.model.condition_sell_2 = +$('input[name=condition_sell_2]:checked', '.form').attr('ng-reflect-value');
        
        this.candlestickConditionDefaultService.save(this.model).subscribe(res => {
            if (res.error) {
                this.isValidateCondition = false;
                this.msgErrorConditions = res.message;
            }
        }, error => {
            this.isValidateCondition = false;
            if (error.hasOwnProperty('statusText')) {
                this.msgErrorConditions = error.statusText;
            }
        });

        // save Ema
        this.model.emaBuy1 = +$('input[name=emaBuy1]:checked', '.form').attr('ng-reflect-value');
        this.model.emaBuy2 = +$('input[name=emaBuy2]:checked', '.form').attr('ng-reflect-value');
        this.model.emaSell1 = +$('input[name=emaSell1]:checked', '.form').attr('ng-reflect-value');
        this.model.emaSell2 = +$('input[name=emaSell2]:checked', '.form').attr('ng-reflect-value');
        this.emaService.save(this.model).subscribe(res => {
            if (res.error) {
                this.isValidateEma = false;
                this.msgErrorEma = res.message;
            }
        }, error => {
            this.isValidateEma = false;
            if (error.hasOwnProperty('statusText')) {
                this.msgErrorEma = error.statusText;
            }
        });
    }

    checkBothBuySell(event: any) {
        let target = event.target || event.srcElement || event.currentTarget;
        let valConditionOne = target.getAttribute('ng-reflect-value');

        this.currentConditionOneBuy = +$('input[name=condition_buy_1]:checked', '.form').attr('ng-reflect-value');
        this.currentConditionOneSell = +$('input[name=condition_sell_1]:checked', '.form').attr('ng-reflect-value');
        if (valConditionOne <= 0) {
            this.currentConditionOneBuy = 0;
            this.currentConditionOneSell = 0;
        }

        this.checkValidate();
    }

    checkValidate() {
        this.isValidateCondition = true;
        if (((this.currentConditionOneBuy * this.currentConditionOneSell) > 0
            || (this.currentConditionOneBuy == 0 && this.currentConditionOneSell == 0))) {

            this.msgErrorConditionOneBuy = null;
            this.msgErrorConditionOneSell = null;
        } else {
            this.isValidateCondition = false;
            if (this.currentConditionOneBuy <= 0) {
                this.msgErrorConditionOneBuy = '1つ買いの条件にはcandlestickがまだ設定されない。';
            }
            if (this.currentConditionOneSell <= 0) {
                this.msgErrorConditionOneSell = '1つ売りの条件にはcandlestickがまだ設定されない。';
            }
        }

        this.checkConditionNotExits();
    }

    checkConditionNotExits() {
        let self = this;
        let objConditionOneBuy = this.coinCondition_1.find(function (obj) {
            return obj.value == self.currentConditionOneBuy;
        });
        let objConditionOneSell = this.coinCondition_1.find(function (obj) {
            return obj.value == self.currentConditionOneSell;
        });
        let objConditionTwoBuy = this.coinCondition_2.find(function (obj) {
            return obj.value == self.currentConditionTwoBuy;
        });
        let objConditionTwoSell = this.coinCondition_2.find(function (obj) {
            return obj.value == self.currentConditionTwoSell;
        });

        if (objConditionOneBuy == undefined || objConditionOneSell == undefined
            || objConditionTwoBuy == undefined || objConditionTwoSell == undefined) {
            self.isValidateCondition = false;
        }
    }

    checkBothEMA(event: any) {
        this.currentEmaBuy1 = +$('input[name=emaBuy1]:checked', '.form').attr('ng-reflect-value');
        this.currentEmaBuy2 = +$('input[name=emaBuy2]:checked', '.form').attr('ng-reflect-value');
        this.currentEmaSell1 = +$('input[name=emaSell1]:checked', '.form').attr('ng-reflect-value');
        this.currentEmaSell2 = +$('input[name=emaSell2]:checked', '.form').attr('ng-reflect-value');

        this.isValidateEma = true;
        if (this.currentEmaBuy1 == this.currentEmaBuy2 || this.currentEmaSell1 == this.currentEmaSell2) {
            this.isValidateEma = false;
            this.msgErrorEma = "EMA1及びEMA2が同じです。";
        }

        this.checkEmaNotExists();
    }

    checkEmaNotExists() {
        let self = this;

        let objEmaBuy1 = self.emaDefault1.find(function (obj) {
            return obj == self.currentEmaBuy1;
        });
        
        let objEmaBuy2 = self.emaDefault2.find(function (obj) {
            return obj == self.currentEmaBuy2;
        });

        if (objEmaBuy1 == undefined || objEmaBuy2 == undefined) {
            self.isValidateEma = false;
            self.msgErrorEma = "無効なEMA値";
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/candlestick-condition-default/candlestick-condition-default.component.ts